import React from 'react'
import Tr from 'translations/Translations';
import {makeStyles} from "@material-ui/core";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import TooltipIcon from "components/icon/TooltipIcon";
import {Mail, MailOutline} from "@material-ui/icons";


const useStyle = makeStyles((theme) => ({
    bold: {
        fontWeight: theme.typography.fontWeightBold
    },
    buttonRow: {
        marginTop: theme.spacing(2),
        textAlign: "end"
    },
    lpColumn: theme.components.table.lpColumn,
    emailColumn: theme.components.table.emailColumn,
    ipColumn: theme.components.table.ipColumn,
    dateTimeColumn: {
        ...theme.components.table.dateTimeColumn,
        textAlign: 'center'
    }
}));

function EmailDeliveriesTable(
    {
        deliveryList
    }) {


    const classes = useStyle();

    const getStatusCellContent = (item) => {
        return <span>
            {Tr(`message_delivery_status_${item.status}`)}
            {!!item.errorMessage && <>
                <br/><span className={classes.bold}>{Tr('details')}: </span>
                <span>${item.errorMessage}</span>
            </>}

        </span>
    }

    return (

        <SimpleTable
            columnClasses={[
                classes.lpColumn,
                classes.emailColumn,
                undefined,
                classes.dateTimeColumn,
            ]}
            headers={["", Tr('email'), Tr('status'), Tr('status_date')]}
            items={deliveryList.map((item, index) => [
                <TooltipIcon color={item.status === 'FAILED' || item.status === 'EMAIL_BLOCKED' ? 'error' : (item.status === 'SUSPENDED' ? 'secondary' : undefined)}
                             Icon={item.status === 'SENT' ? Mail : MailOutline} tooltip={Tr(`message_delivery_status_info_${item.status}`)}/>,
                item.recipient,
                getStatusCellContent(item),
                item.deliveryDate ? moment(item.deliveryDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT) : '--'
            ])}
        />

    )
}

export default EmailDeliveriesTable;